<div *ngIf="creatorDetails" [formGroup]="form" class="user-details">
  <div class="avatar">
    <app-upload-image
      [profile]="true"
      preview="{{ form.get('creator_picture')?.value }} "
      formControlName="creator_picture"
    >
    </app-upload-image>
  </div>
  <div class="details">
    <div class="subtitle typography-heading3-thin">
      {{ creatorDetails.creator_name }}
    </div>
    <div class="email typography-body3-thin">
      {{ creatorDetails.publisher_username }}
    </div>
  </div>
</div>
